angular.module 'zc.users'

.controller 'ForgotUserPasswordCtrl', ($scope, $translate, Page, Devise) ->
  $translate('users.controllers.password.resetPassword').then (translation) ->
    Page.setTitle translation

  Page.setBodyClass 'account-bg'
  $scope.submit = (user) ->
    Devise.password user.email



// WEBPACK FOOTER //
// ./src/zenclerk_modules/users/controllers/password/new_controller.js.coffee